export default __webpack_public_path__ + "static/media/burgerLogo.49f513ac.jfif";